import * as React from "react";

function ArrowUpFromLineIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M360 431.1H24c-13.25 0-24 10.76-24 24.02C0 469.2 10.75 480 24 480h336c13.25 0 24-10.76 24-24.02 0-13.28-10.7-24.88-24-24.88zM81.47 208.3l86.53-92v243.6c0 13.26 10.75 24.05 24 24.05s24-10.79 24-24.05V116.3l86.53 91.98c4.77 5.02 11.07 7.52 17.47 7.52 5.906 0 11.81-2.158 16.44-6.536 9.656-9.068 10.12-24.27 1.031-33.93l-128-136.1c-9.062-9.694-25.88-9.694-34.94 0l-128 136.1C37.44 185 37.91 200.2 47.56 209.3c9.63 9.1 24.82 7.8 33.91-1z"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpFromLineIcon);
export default ForwardRef;